import { DollarCircleFilled, EuroCircleFilled, PoundCircleFilled } from '@ant-design/icons';
import { ComponentType } from 'react';

const currencyIcons: Record<string, ComponentType> = {
    EUR: EuroCircleFilled,
    GBP: PoundCircleFilled,
    USD: DollarCircleFilled,
};

// Currencies without an icon return undefined, so the total is shown without one.
export const getCurrencyIcon = (currency: string | undefined): ComponentType | undefined => {
    if (!currency) return undefined;

    return currencyIcons[currency.toUpperCase()];
};
